<template>
  <div class="nav-buttons">
    <nav>
      <router-link to="/">Home</router-link> 
      <router-link to="/value">Value</router-link>
      <router-link to="/service"> Services</router-link>
      <router-link to="/contact"> Contact</router-link>      
    </nav>
  </div>

  <router-view/>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}



nav {
  padding: 20px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
  text-decoration: underline;
  padding: 10px;
  margin-left: 10px;
}

nav a.router-link-exact-active {
  color: white;
  background: blue;
 
}

.nav-buttons {
    background-size: cover;
    background-color: rgb(238, 238, 238);
    background-position: center; 
    display: flex;
    align-items: center;
    justify-content: center;
    border-style: solid;
    border-color: gray;
}
</style>
